"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6818],{

/***/ 15320:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ CandleSubscriptionOrderItem_CandleSubscriptionOrderItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(6493);
;// CONCATENATED MODULE: ./src/compositions/orderItems/CandleSubscriptionOrderItem/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "What you’re getting..."
    },
    text: {
        en: "\n      A subscription to receive a scented candle each month from brands you know and love.\n      Billed monthly, renews automatically, and ships from our warehouse with your fragrance.\n    "
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/CandleSubscriptionOrderItem/CandleSubscriptionOrderItem.tsx







var CandleSubscriptionOrderItem = function(props) {
    var className = props.className, data = props.data;
    var price = data.price, subscriptionCandle = data.subscriptionCandle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
        className: className,
        "data-testid": "orderCandleSubscription",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h9",
                message: messages.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-16 flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: messages.text,
                        style: "p2",
                        color: "black"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "ml-24",
                        message: price,
                        style: "t2",
                        "data-testid": "price"
                    })
                ]
            }),
            Boolean(subscriptionCandle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderProductBase/* default */.Z, {
                className: "mt-24",
                image: subscriptionCandle.image,
                rebrandImage: subscriptionCandle.rebrandImage,
                "data-testid": "subscriptionCandle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "font-semibold",
                        message: subscriptionCandle.brand,
                        style: "p2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: subscriptionCandle.name,
                        style: "p2"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const CandleSubscriptionOrderItem_CandleSubscriptionOrderItem = (CandleSubscriptionOrderItem);


/***/ }),

/***/ 91282:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ CaseSubscriptionOrderItem_CaseSubscriptionOrderItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(6493);
;// CONCATENATED MODULE: ./src/compositions/orderItems/CaseSubscriptionOrderItem/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "What you’re getting..."
    },
    text: {
        en: "\n      A month-to-month subscription to Scentbird cases. Billed monthly, renews automatically,\n      and ships from our warehouse with your fragrance.\n    "
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/CaseSubscriptionOrderItem/CaseSubscriptionOrderItem.tsx







var CaseSubscriptionOrderItem = function(props) {
    var className = props.className, data = props.data;
    var price = data.price, subscriptionCase = data.subscriptionCase;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
        className: className,
        "data-testid": "orderCaseSubscription",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h9",
                message: messages.title,
                color: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-16 flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: messages.text,
                        style: "p2",
                        color: "black"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "ml-24",
                        message: price,
                        style: "t2",
                        "data-testid": "price"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
                className: "mt-24",
                image: subscriptionCase.image,
                rebrandImage: subscriptionCase.rebrandImage,
                "data-testid": "subscriptionCase",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: subscriptionCase.name,
                    style: "p2"
                })
            }, "case")
        ]
    });
};
/* harmony default export */ const CaseSubscriptionOrderItem_CaseSubscriptionOrderItem = (CaseSubscriptionOrderItem);


/***/ }),

/***/ 26163:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ GiftCardOrderItem_GiftCardOrderItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(17696);
// EXTERNAL MODULE: ./local_modules/date/index.ts
var date = __webpack_require__(64895);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton.tsx + 1 modules
var OrderItemRemoveButton = __webpack_require__(65906);
;// CONCATENATED MODULE: ./src/compositions/orderItems/GiftCardOrderItem/messages.ts
/* harmony default export */ const messages = ({
    to: {
        en: "<b>To:</b>"
    },
    from: {
        en: "<b>From:</b>"
    },
    value: {
        en: "<b>Value:</b> {price}"
    },
    date: {
        en: "<b>Send date:</b> {date}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/GiftCardOrderItem/GiftCardOrderItem.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var GiftCardOrderItem = function(props) {
    var className = props.className, _props_data = props.data, price = _props_data.price, recipient = _props_data.recipient, productId = _props_data.productId, type = _props_data.type, sender = _props_data.sender, withRemoveButton = props.withRemoveButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, "flex items-start"),
        "data-testid": "orderGiftCard",
        children: [
            withRemoveButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemRemoveButton/* default */.Z, {
                input: {
                    giftCardItem: {
                        productId: productId,
                        type: type,
                        recipient: recipient
                    }
                },
                metadata: {
                    productType: "Gift card",
                    placement: "Drawer cart",
                    productId: productId
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "flex-none rounded bg-gold-30 px-16 py-12 text-white",
                style: "h6",
                message: price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-40 min-w-1 flex-1 break-words",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                    style: "p2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                    value: messages.to,
                                    html: true
                                }),
                                "\xa0",
                                recipient.name,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                recipient.email
                            ]
                        }),
                        Boolean(sender === null || sender === void 0 ? void 0 : sender.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                    value: messages.from,
                                    html: true
                                }),
                                "\xa0",
                                sender.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                value: _object_spread_props(_object_spread({}, messages.value), {
                                    values: {
                                        price: price
                                    }
                                }),
                                html: true
                            })
                        }),
                        Boolean(recipient.date) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                value: _object_spread_props(_object_spread({}, messages.date), {
                                    values: {
                                        date: (0,date/* default */.ZP)(recipient.date).format("L")
                                    }
                                }),
                                html: true
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ const GiftCardOrderItem_GiftCardOrderItem = (GiftCardOrderItem);


/***/ }),

/***/ 31192:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54939);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14939);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31627);
/* harmony import */ var compositions_orderItems_OrderItemBase_OrderItemBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28625);
/* harmony import */ var compositions_orderItems_OrderProductBase_OrderProductBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6493);







var GiftSubscriptionOfferOrderItem = function(props) {
    var className = props.className, data = props.data;
    var description = data.description, image = data.image, priceOfferText = data.priceOfferText, whatYouAreGetting = data.whatYouAreGetting;
    if (whatYouAreGetting) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(compositions_orderItems_OrderItemBase_OrderItemBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: className,
        "data-testid": "orderGiftSubscriptionOfferProduct",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(compositions_orderItems_OrderProductBase_OrderProductBase__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            image: image,
            rebrandImage: image,
            name: description,
            priceNode: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                message: priceOfferText,
                style: "t2"
            })
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (GiftSubscriptionOfferOrderItem);


/***/ }),

/***/ 90549:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ GiftSubscriptionOrderItem_GiftSubscriptionOrderItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(6493);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton.tsx + 1 modules
var OrderItemRemoveButton = __webpack_require__(65906);
;// CONCATENATED MODULE: ./src/compositions/orderItems/GiftSubscriptionOrderItem/messages.ts
/* harmony default export */ const messages = ({
    oneTime: {
        en: "One-time purchase"
    },
    label: {
        en: "Gift Subscription"
    },
    months: {
        en: "{months, plural, one {# month} other {# months}}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/GiftSubscriptionOrderItem/GiftSubscriptionOrderItem.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var GiftSubscriptionOrderItem = function(props) {
    var className = props.className, _props_data = props.data, label = _props_data.label, price = _props_data.price, months = _props_data.months, recipient = _props_data.recipient, withRemoveButton = props.withRemoveButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
        className: className,
        "data-testid": "orderGiftSubscription",
        children: [
            withRemoveButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemRemoveButton/* default */.Z, {
                input: {
                    giftSubscriptionItem: {
                        months: months,
                        recipient: recipient
                    }
                },
                metadata: {
                    productType: "Gift subscription",
                    placement: "Drawer cart"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderProductBase/* default */.Z, {
                price: price,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: messages.oneTime,
                        style: "h9"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "mt-8",
                        message: label || messages.label,
                        style: "t2"
                    }),
                    months && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: _object_spread_props(_object_spread({}, messages.months), {
                            values: {
                                months: months
                            }
                        }),
                        style: "p2"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const GiftSubscriptionOrderItem_GiftSubscriptionOrderItem = (GiftSubscriptionOrderItem);


/***/ }),

/***/ 97293:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31627);





var OrderBillItem = function(props) {
    var className = props.className, disabled = props.disabled, label = props.label, note = props.note, noteColor = props.noteColor, value = props.value, isLarge = props.isLarge, dataTestId = props["data-testid"];
    var priceColor = isLarge ? "gold-50" : "black";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, "flex justify-between"),
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        message: label,
                        style: isLarge ? "p1" : "p2",
                        color: "black",
                        "data-testid": "".concat(dataTestId, "Label")
                    }),
                    Boolean(note) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        className: "mt-4",
                        message: note,
                        style: "p4",
                        color: noteColor || "gray-80",
                        html: true,
                        "data-testid": "".concat(dataTestId, "Note")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: "ml-16 whitespace-nowrap",
                message: value,
                style: isLarge ? "t1" : "t2",
                color: disabled ? "gray-50" : priceColor,
                "data-testid": "".concat(dataTestId, "Value")
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderBillItem);


/***/ }),

/***/ 28625:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



var OrderItemBase = function(props) {
    var children = props.children, className = props.className, dataTestId = props["data-testid"];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "relative rounded bg-light-beige px-16 py-24"),
        "data-testid": dataTestId,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderItemBase);


/***/ }),

/***/ 65906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ OrderItemRemoveButton_OrderItemRemoveButton)
});

// UNUSED EXPORTS: bgColorToClassName

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(5649);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83901);
// EXTERNAL MODULE: ./src/modules/cart/index.ts + 4 modules
var cart = __webpack_require__(65337);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/orderItems/OrderItemRemoveButton/messages.ts
/* harmony default export */ const OrderItemRemoveButton_messages = ({
    confirmation: {
        text: {
            en: "Would you like to remove this item from your cart?"
        },
        no: {
            en: "No, keep it"
        },
        yes: {
            en: "Yes, remove it!"
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}











var bgColorToClassName = {
    "gray-20": "bg-gray-20",
    "light-beige": "bg-light-beige"
};
var OrderItemRemoveButton = function(props) {
    var _props_bgColor = props.bgColor, bgColor = _props_bgColor === void 0 ? "light-beige" : _props_bgColor, input = props.input, metadata = props.metadata;
    var intl = (0,useIntl/* default */.Z)();
    var _useState = _sliced_to_array((0,react.useState)(false), 2), isOpen = _useState[0], setOpen = _useState[1];
    var _useCartDelete = _sliced_to_array((0,cart/* useCartDelete */.Hu)(), 2), deleteMutation = _useCartDelete[0], isFetching = _useCartDelete[1].isFetching;
    var handleCancel = function() {
        setOpen(false);
    };
    var handleOpen = function() {
        setOpen(true);
    };
    var handleConfirm = function() {
        var _ref = _async_to_generator(function() {
            var _getAnalyticsContext, page, pageType, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _getAnalyticsContext = (0,context/* getAnalyticsContext */.cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
                        return [
                            4,
                            deleteMutation(_object_spread_props(_object_spread({}, input), {
                                metadata: _object_spread({
                                    page: page,
                                    pageType: pageType
                                }, input === null || input === void 0 ? void 0 : input.metadata)
                            }))
                        ];
                    case 1:
                        _state.sent();
                        (0,analytics/* track */.j)("Cart product remove", metadata);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        (0,errors/* processError */.wY)(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "absolute right-0 top-0 mr-8 mt-8 cursor-pointer",
                title: intl.formatMessage(messages/* default */.Z.remove),
                onClick: handleOpen,
                "data-testid": "removeOrderItem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "16/close"
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("absolute inset-0 z-overlay rounded", bgColorToClassName[bgColor]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "align-center absolute inset-0 flex max-h-[254rem] flex-col justify-center text-center",
                    "aria-busy": isFetching,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "p3",
                            message: OrderItemRemoveButton_messages.confirmation.text
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: 38,
                                    style: "secondary",
                                    title: OrderItemRemoveButton_messages.confirmation.no,
                                    disabled: isFetching,
                                    onClick: handleCancel,
                                    "data-testid": "removeOrderItemCancel"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "ml-12",
                                    size: 38,
                                    style: "primary",
                                    title: OrderItemRemoveButton_messages.confirmation.yes,
                                    disabled: isFetching,
                                    onClick: handleConfirm,
                                    "data-testid": "removeOrderItemConfirm"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ const OrderItemRemoveButton_OrderItemRemoveButton = (/*#__PURE__*/(0,react.memo)(OrderItemRemoveButton));


/***/ }),

/***/ 72056:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10430);



var OrderItemSkeleton = function(props) {
    var _props_bgColor = props.bgColor, bgColor = _props_bgColor === void 0 ? "light-beige" : _props_bgColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        bgColor: bgColor,
        h: 142
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderItemSkeleton);


/***/ }),

/***/ 61711:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);




var OrderItemsContainer = function(props) {
    var children = props.children, className = props.className;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, !isMobile && "border-solid-gray-30 w-full rounded bg-white p-40"),
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderItemsContainer);


/***/ }),

/***/ 6493:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ OrderProductBase_OrderProductBase)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(17696);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
;// CONCATENATED MODULE: ./src/compositions/orderItems/OrderProductBase/messages.ts
/* harmony default export */ const messages = ({
    free: {
        en: "Free"
    },
    quantity: {
        en: "Quantity: {quantity}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/OrderProductBase/images/default.png
const default_namespaceObject = __webpack_require__.p + "images/default_06284e.png";
;// CONCATENATED MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var OrderProductBase = function(props) {
    var children = props.children, className = props.className, image = props.image, rebrandImage = props.rebrandImage, name = props.name, brand = props.brand, price = props.price, quantity = props.quantity, size = props.size, priceNode = props.priceNode, beforeNode = props.beforeNode, afterNode = props.afterNode, dataTestId = props["data-testid"], typeGroup = props.typeGroup;
    var isFree = price === null;
    var showQuantity = typeGroup === "PerfumeCase" ? quantity > 0 : quantity > 1;
    var showSize = Boolean(size);
    var content = children || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            beforeNode,
            Boolean(brand) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: brand,
                style: "t2",
                "data-testid": "productBrand"
            }),
            Boolean(name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: name,
                style: "p3",
                "data-testid": "productName"
            }),
            (showSize || showQuantity) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                style: "p5",
                color: "gold-70",
                children: [
                    showQuantity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                    value: _object_spread_props(_object_spread({}, messages.quantity), {
                                        values: {
                                            quantity: quantity
                                        }
                                    })
                                })
                            }),
                            showSize && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " – "
                            })
                        ]
                    }),
                    showSize && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "data-testid": "volume",
                        children: size
                    })
                ]
            }),
            afterNode
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "flex items-center"),
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                className: "w-72 flex-none",
                bgColor: "light-beige",
                src: rebrandImage || image || default_namespaceObject
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-16 min-w-1 flex-1",
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-24 flex-none",
                children: [
                    priceNode,
                    Boolean(price || isFree) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: isFree ? messages.free : price,
                        style: isFree ? "p2" : "t2",
                        "data-testid": "price"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const OrderProductBase_OrderProductBase = (OrderProductBase);


/***/ }),

/***/ 30852:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductOrderItem_ProductOrderItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/modules/priceSelection/index.tsx
var priceSelection = __webpack_require__(19792);
// EXTERNAL MODULE: ./src/modules/products/useProductGiftPromo.ts + 1 modules
var useProductGiftPromo = __webpack_require__(78053);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(6493);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton.tsx + 1 modules
var OrderItemRemoveButton = __webpack_require__(65906);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.to-string.js
var es_error_to_string = __webpack_require__(86011);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.date.to-string.js
var es_date_to_string = __webpack_require__(45942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(61737);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(5649);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83901);
// EXTERNAL MODULE: ./local_modules/notifications/manager.ts
var manager = __webpack_require__(72065);
// EXTERNAL MODULE: ./src/modules/cart/index.ts + 4 modules
var cart = __webpack_require__(65337);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/compositions/orderItems/OrderItemQuantity/OrderItemQuantity.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}













var OrderItemQuantity = function(props) {
    var className = props.className, buttonClassName = props.buttonClassName, productLineItemId = props.productLineItemId, value = props.value, metadata = props.metadata;
    var _useCartModify = _sliced_to_array((0,cart/* useCartModify */.sd)(), 2), cartModify = _useCartModify[0], isFetching = _useCartModify[1].isFetching;
    var _useMemo = _sliced_to_array((0,react.useMemo)(function() {
        var handleChange = function(delta) {
            return /*#__PURE__*/ _async_to_generator(function() {
                var _getAnalyticsContext, page, pageType, _$error, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            _getAnalyticsContext = (0,context/* getAnalyticsContext */.cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
                            return [
                                4,
                                cartModify({
                                    productItems: [
                                        {
                                            productLineItemId: productLineItemId,
                                            quantity: value + delta
                                        }
                                    ],
                                    metadata: {
                                        page: page,
                                        pageType: pageType,
                                        placement: "Cart"
                                    }
                                })
                            ];
                        case 1:
                            _$error = _state.sent().error;
                            if ((_$error === null || _$error === void 0 ? void 0 : _$error.__typename) === "CartError" && (_$error === null || _$error === void 0 ? void 0 : _$error.cartErrorCode) === "LEP_COUNT_ISSUE") {
                                (0,manager/* openNotification */.Ym)("error", {
                                    message: _$error.message
                                });
                            }
                            if (value + delta <= 0) {
                                (0,analytics/* track */.j)("Cart product remove", metadata);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            (0,errors/* processError */.wY)(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
        };
        return [
            handleChange(-1),
            handleChange(1)
        ];
    }, [
        cartModify,
        productLineItemId,
        value,
        metadata
    ]), 2), decrease = _useMemo[0], increase = _useMemo[1];
    var buttonClassname = (0,clsx/* default */.Z)("h-s24 w-s24 cursor-pointer rounded-full bg-pink disabled:opacity-50", buttonClassName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "inline-flex items-center justify-start text-center"),
        "aria-busy": isFetching,
        "data-testid": "quantity",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: buttonClassname,
                type: "button",
                onClick: decrease,
                disabled: isFetching,
                "data-testid": "decrease",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "24/minus"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: (0,clsx/* default */.Z)("mx-12 min-w-[20rem]"),
                style: "h8",
                message: value.toString(),
                "data-testid": "orderItemCount"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: buttonClassname,
                type: "button",
                onClick: increase,
                disabled: isFetching,
                "data-testid": "increase",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "24/plus"
                })
            })
        ]
    });
};
/* harmony default export */ const OrderItemQuantity_OrderItemQuantity = (OrderItemQuantity);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(8055);
// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(28733);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
;// CONCATENATED MODULE: ./src/compositions/orderItems/ProductOrderItem/components/PrivateSaleItems/PrivateSaleItems.tsx









var PrivateSaleItems = function(props) {
    var _props_product = props.product, quantity = _props_product.quantity, productId = _props_product.productId;
    // TODO don't forget about rebrandImage when privateSale query will be moved to web-api - added on 21.01.2022 by sonatskiy
    var _usePrivateSale = (0,usePrivateSale/* default */.Z)(), privateSaleList = _usePrivateSale.privateSaleList, isFetching = _usePrivateSale.isFetching;
    // find required private sale by product id
    var privateSale = privateSaleList === null || privateSaleList === void 0 ? void 0 : privateSaleList.find(function(item) {
        return item.id === productId;
    });
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                className: "mt-24",
                pw: 100,
                h: 72
            })
        });
    }
    // return null, if we can't find private sale
    if (!privateSale) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "mt-24 bg-gray-30"
            }),
            privateSale.products.map(function(param) {
                var id = param.id, name = param.name, _param_brandInfo = param.brandInfo, brand = _param_brandInfo.name, image = param.image, rebrandImage = param.rebrandImage;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
                    className: "mt-24",
                    image: image,
                    rebrandImage: rebrandImage,
                    name: name,
                    brand: brand,
                    quantity: quantity,
                    "data-testid": "privateSaleItem"
                }, id);
            })
        ]
    });
};
/* harmony default export */ const PrivateSaleItems_PrivateSaleItems = (PrivateSaleItems);

// EXTERNAL MODULE: ./src/modules/academy/index.ts + 2 modules
var academy = __webpack_require__(74317);
// EXTERNAL MODULE: ./src/modules/payment/inquire/useInquire.ts
var useInquire = __webpack_require__(88828);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
;// CONCATENATED MODULE: ./src/compositions/orderItems/ProductOrderItem/components/AcademyCourseOrderItem/components/AcademyCoursePrice/messages.ts
/* harmony default export */ const messages = ({
    regular: {
        en: "Regular price"
    },
    memberPrice: {
        en: "Member price"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/ProductOrderItem/components/AcademyCourseOrderItem/components/AcademyCoursePrice/AcademyCoursePrice.tsx








var AcademyCoursePrice = function(props) {
    var _cartContext_cart, _inquireContext_orderData;
    var price = props.price, prices = props.prices, isCart = props.isCart;
    // ATTN we don't load the cart, we use it context. So it will be null on the payment and thank you pages
    var cartContext = (0,cart/* useCartContext */.iQ)();
    var inquireContext = (0,useInquire/* default */.Z)();
    // we either in cart or payment page
    var hasSubscriptionInOrder = (cartContext === null || cartContext === void 0 ? void 0 : (_cartContext_cart = cartContext.cart) === null || _cartContext_cart === void 0 ? void 0 : _cartContext_cart.hasSubscription) || (inquireContext === null || inquireContext === void 0 ? void 0 : (_inquireContext_orderData = inquireContext.orderData) === null || _inquireContext_orderData === void 0 ? void 0 : _inquireContext_orderData.hasSubscription);
    var subscription = (0,subscription_subscription/* useSubscription */.m)().subscription;
    var regularPrice = (0,formatPrice/* default */.Z)(prices.standardPrice.amountCents);
    var membershipPrice = (0,formatPrice/* default */.Z)(prices.membershipPrice.amountCents);
    var MembershipPrice = function(param) {
        var className = param.className, dataTestId = param.dataTestId;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: className,
                    style: "p6",
                    color: "gold-70",
                    message: messages.memberPrice
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: "h8",
                    color: "gold-70",
                    "data-testid": dataTestId,
                    children: membershipPrice
                })
            ]
        });
    };
    var RegularPrice = function(param) {
        var className = param.className, strikeThrough = param.strikeThrough, dataTestId = param.dataTestId;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: className,
                    style: "p6",
                    message: messages.regular
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    style: "h8",
                    tag: strikeThrough ? "s" : "div",
                    "data-testid": dataTestId,
                    children: regularPrice
                })
            ]
        });
    };
    // in cart
    if (isCart) {
        // Case 1. Use with active subscription
        if (subscription.isActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipPrice, {
                        dataTestId: "price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularPrice, {
                        className: "mt-8",
                        strikeThrough: true,
                        dataTestId: "oldPrice"
                    })
                ]
            });
        } else if (hasSubscriptionInOrder) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularPrice, {
                        strikeThrough: true,
                        dataTestId: "oldPrice"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipPrice, {
                        className: "mt-8",
                        dataTestId: "price"
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularPrice, {
                        dataTestId: "price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipPrice, {
                        className: "mt-8",
                        dataTestId: "membershipPrice"
                    })
                ]
            });
        }
    } else if (inquireContext) {
        if (subscription.isActive || hasSubscriptionInOrder) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipPrice, {
                        dataTestId: "price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularPrice, {
                        className: "mt-8",
                        strikeThrough: true,
                        dataTestId: "oldPrice"
                    })
                ]
            });
        }
    } else {
        // Case 1. Member in thankyou page
        if (subscription.isActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipPrice, {
                    dataTestId: "price"
                })
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        style: "t2",
        message: price,
        "data-testid": "price"
    });
};
/* harmony default export */ const AcademyCoursePrice_AcademyCoursePrice = (AcademyCoursePrice);

;// CONCATENATED MODULE: ./src/compositions/orderItems/ProductOrderItem/components/AcademyCourseOrderItem/AcademyCourseOrderItem.tsx
function AcademyCourseOrderItem_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AcademyCourseOrderItem_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function AcademyCourseOrderItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AcademyCourseOrderItem_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AcademyCourseOrderItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AcademyCourseOrderItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AcademyCourseOrderItem_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AcademyCourseOrderItem_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AcademyCourseOrderItem_sliced_to_array(arr, i) {
    return AcademyCourseOrderItem_array_with_holes(arr) || AcademyCourseOrderItem_iterable_to_array_limit(arr, i) || AcademyCourseOrderItem_unsupported_iterable_to_array(arr, i) || AcademyCourseOrderItem_non_iterable_rest();
}
function AcademyCourseOrderItem_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AcademyCourseOrderItem_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AcademyCourseOrderItem_array_like_to_array(o, minLen);
}
function AcademyCourseOrderItem_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}










var AcademyCourseOrderItem = function(props) {
    var className = props.className, data = props.data, withRemoveButton = props.withRemoveButton, dataTestId = props["data-testid"];
    var id = data.id, name = data.name, brand = data.brand, image = data.image, rebrandImage = data.rebrandImage, quantity = data.quantity, price = data.price, productId = data.productId;
    var _useAcademyCourse = (0,academy/* useAcademyCourse */.sc)({
        productId: productId
    }), courseData = _useAcademyCourse.data;
    var _useCartModify = AcademyCourseOrderItem_sliced_to_array((0,cart/* useCartModify */.sd)(), 2), cartModify = _useCartModify[0], _useCartModify_ = _useCartModify[1], isCartModifyFetching = _useCartModify_.isFetching;
    (0,react.useEffect)(function() {
        if (quantity > 1) {
            void AcademyCourseOrderItem_async_to_generator(function() {
                var _getAnalyticsContext, page, pageType, error;
                return AcademyCourseOrderItem_ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            _getAnalyticsContext = (0,context/* getAnalyticsContext */.cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
                            return [
                                4,
                                cartModify({
                                    productItems: [
                                        {
                                            productLineItemId: id,
                                            quantity: 1
                                        }
                                    ],
                                    metadata: {
                                        page: page,
                                        pageType: pageType,
                                        placement: "Cart"
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            (0,errors/* processError */.wY)(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }, [
        quantity,
        cartModify,
        id
    ]);
    var tradingItem = courseData === null || courseData === void 0 ? void 0 : courseData.product.tradingItems.items[0];
    // cart mode
    var priceNode = tradingItem && !isCartModifyFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-right",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AcademyCoursePrice_AcademyCoursePrice, {
            price: price,
            prices: tradingItem.prices,
            isCart: withRemoveButton
        })
    }) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
        className: className,
        image: image,
        rebrandImage: rebrandImage,
        name: name,
        quantity: quantity,
        priceNode: priceNode,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const AcademyCourseOrderItem_AcademyCourseOrderItem = (AcademyCourseOrderItem);

;// CONCATENATED MODULE: ./src/compositions/orderItems/ProductOrderItem/messages.ts
/* harmony default export */ const ProductOrderItem_messages = ({
    oneTime: {
        en: "One-time purchase"
    },
    giftWithSpendThresholdFetching: {
        en: "Gift with purchase"
    },
    giftWithSpendThreshold: {
        en: "Gift with purchase<br />over {price}"
    },
    varietyProductName: {
        en: "{name} with {variety} Scent"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/ProductOrderItem/ProductOrderItem.tsx
function ProductOrderItem_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return ProductOrderItem_array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || ProductOrderItem_unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function ProductOrderItem_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductOrderItem_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductOrderItem_array_like_to_array(o, minLen);
}
















var ProductOrderItem = function(props) {
    var _data_offerProducts;
    var className = props.className, data = props.data, withRemoveButton = props.withRemoveButton;
    var _useProductGiftPromo = (0,useProductGiftPromo/* default */.Z)(), subTotal = _useProductGiftPromo.subTotal, isFetching = _useProductGiftPromo.isFetching;
    var items = ((_data_offerProducts = data.offerProducts) === null || _data_offerProducts === void 0 ? void 0 : _data_offerProducts.length) ? [
        data
    ].concat(_to_consumable_array(data.offerProducts)) : [
        data
    ];
    var brand = data.brand, category = data.category, type = data.type, fullName = data.fullName, gender = data.gender, id = data.id, name = data.name, offer = data.offer, size = data.size, variety = data.variety;
    var _ref = variety || {}, varietyName = _ref.name;
    var productLineItemId = id;
    var isTossIn = offer === "TOSSIN" || offer === "TOSSIN_EMAIL";
    var isPrivateSale = type === "FlashSale";
    var isAcademyCourse = type === "AcademyCourse";
    var nameLine = varietyName ? _object_spread_props(_object_spread({}, ProductOrderItem_messages.varietyProductName), {
        values: {
            name: name,
            variety: varietyName
        }
    }) : name;
    var removeMetadata = {
        productType: "Ecommerce",
        placement: "Drawer cart",
        productId: id,
        productBrand: brand,
        productFullName: fullName,
        productCategory: category,
        productVolume: size,
        productGender: gender
    };
    var priceChannel;
    if (isPrivateSale) {
        priceChannel = priceSelection/* priceChannels */.GW.privateSale;
    } else if (isTossIn) {
        priceChannel = priceSelection/* priceChannels */.GW.tossIn;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(priceSelection/* PriceSelectionProvider */.CT, {
        channel: priceChannel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
            className: className,
            "data-testid": "orderProduct",
            children: [
                withRemoveButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemRemoveButton/* default */.Z, {
                    input: {
                        productItems: [
                            {
                                productLineItemId: productLineItemId
                            }
                        ]
                    },
                    metadata: removeMetadata
                }),
                items.map(function(item, index) {
                    var id = item.id, image = item.image, rebrandImage = item.rebrandImage, brand = item.brand, name = item.name, price = item.price, size = item.size, quantity = item.quantity, type = item.type, typeGroup = item.typeGroup;
                    var isFirst = index === 0;
                    var dataTestId = isFirst ? "primaryProduct" : "offerProduct";
                    if (isAcademyCourse && isFirst) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AcademyCourseOrderItem_AcademyCourseOrderItem, {
                                    className: index > 0 ? "mt-24" : null,
                                    data: data,
                                    withRemoveButton: withRemoveButton,
                                    "data-testid": dataTestId
                                }),
                                items.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                    className: "mt-24 bg-gray-30"
                                })
                            ]
                        }, id);
                    }
                    var withQuantityEditor = withRemoveButton && isFirst && !isAcademyCourse;
                    var withOneTimeLabel = isFirst && !isTossIn && !isPrivateSale && !isAcademyCourse;
                    var withSize = !isPrivateSale && !isAcademyCourse && typeGroup !== "PerfumeCase";
                    var isAcademyCourseKit = type === "AcademyCourseKit";
                    var label = ProductOrderItem_messages.oneTime;
                    if (offer === "GIFT_FOR_SUBTOTAL") {
                        label = isFetching || !subTotal ? ProductOrderItem_messages.giftWithSpendThresholdFetching : _object_spread_props(_object_spread({}, ProductOrderItem_messages.giftWithSpendThreshold), {
                            values: {
                                price: (0,formatPrice/* default */.Z)(subTotal.amountCents, {
                                    removeZeroCents: true
                                })
                            }
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
                        className: index > 0 ? "mt-24" : null,
                        image: image,
                        rebrandImage: rebrandImage,
                        name: isFirst ? nameLine : name,
                        brand: isAcademyCourseKit ? null : brand,
                        quantity: withQuantityEditor && typeGroup !== "PerfumeCase" ? null : quantity,
                        typeGroup: typeGroup,
                        size: withSize ? size : null,
                        price: price,
                        afterNode: withQuantityEditor && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemQuantity_OrderItemQuantity, {
                            className: "mt-8",
                            productLineItemId: productLineItemId,
                            value: quantity,
                            metadata: removeMetadata
                        }),
                        beforeNode: withOneTimeLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mb-8",
                            message: label,
                            style: "h9",
                            html: true
                        }),
                        "data-testid": dataTestId
                    }, id);
                }),
                isPrivateSale && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateSaleItems_PrivateSaleItems, {
                    product: data
                })
            ]
        })
    });
};
/* harmony default export */ const ProductOrderItem_ProductOrderItem = (ProductOrderItem);


/***/ }),

/***/ 55916:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ QueueProductOrderItem_QueueProductOrderItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/modules/priceSelection/index.tsx
var priceSelection = __webpack_require__(19792);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(6493);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton.tsx + 1 modules
var OrderItemRemoveButton = __webpack_require__(65906);
;// CONCATENATED MODULE: ./src/compositions/orderItems/QueueProductOrderItem/messages.ts
/* harmony default export */ const messages = ({
    productType: {
        en: "Buy Your Queue item"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/QueueProductOrderItem/QueueProductOrderItem.tsx









var QueueProductOrderItem = function(props) {
    var className = props.className, data = props.data, withRemoveButton = props.withRemoveButton;
    var id = data.id, brand = data.brand, name = data.name, size = data.size, image = data.image, rebrandImage = data.rebrandImage, price = data.price, category = data.category, gender = data.gender, fullName = data.fullName, quantity = data.quantity, offer = data.offer;
    var productTypeNode = offer !== "GIFT_FOR_BUY_QUEUE" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: "mb-8",
        style: "h9",
        message: messages.productType
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(priceSelection/* PriceSelectionProvider */.CT, {
        channel: priceSelection/* priceChannels */.GW.buyQueue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
            className: className,
            "data-testid": "orderQueueItem",
            children: [
                withRemoveButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemRemoveButton/* default */.Z, {
                    input: {
                        queueItems: [
                            {
                                queueItemId: id
                            }
                        ]
                    },
                    metadata: {
                        productType: "Ecommerce",
                        placement: "Drawer cart",
                        productId: id,
                        productBrand: brand,
                        productFullName: fullName,
                        productCategory: category,
                        productVolume: size,
                        productGender: gender
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
                    image: image,
                    rebrandImage: rebrandImage,
                    name: name,
                    brand: brand,
                    price: price,
                    quantity: quantity,
                    size: size,
                    beforeNode: productTypeNode
                })
            ]
        })
    });
};
/* harmony default export */ const QueueProductOrderItem_QueueProductOrderItem = (QueueProductOrderItem);


/***/ }),

/***/ 98185:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ RedeemedGiftSubscriptionOrderItem_RedeemedGiftSubscriptionOrderItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(6493);
;// CONCATENATED MODULE: ./src/compositions/orderItems/RedeemedGiftSubscriptionOrderItem/messages.ts
/* harmony default export */ const messages = ({
    from: {
        en: "Gift from {name}"
    },
    label: {
        en: "Gift subscription"
    },
    months: {
        en: "{months, plural, one {# month} other {# months}}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/RedeemedGiftSubscriptionOrderItem/RedeemedGiftSubscriptionOrderItem.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var RedeemedGiftSubscriptionOrderItem = function(props) {
    var className = props.className, _props_data = props.data, months = _props_data.months, name = _props_data.sender.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemBase/* default */.Z, {
        className: className,
        "data-testid": "orderRedeemedGiftSubscription",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderProductBase/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: _object_spread_props(_object_spread({}, messages.from), {
                        values: {
                            name: name
                        }
                    }),
                    style: "h9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-8",
                    message: messages.label,
                    style: "t2"
                }),
                months && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: _object_spread_props(_object_spread({}, messages.months), {
                        values: {
                            months: months
                        }
                    }),
                    style: "p2"
                })
            ]
        })
    });
};
/* harmony default export */ const RedeemedGiftSubscriptionOrderItem_RedeemedGiftSubscriptionOrderItem = (RedeemedGiftSubscriptionOrderItem);


/***/ }),

/***/ 12278:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscriptionOrderItem_SubscriptionOrderItem)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(54939);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(14939);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(17696);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/OfferLabel/OfferLabel.tsx
var OfferLabel = __webpack_require__(58354);
// EXTERNAL MODULE: ./src/components/feedback/Explanation/Explanation.tsx + 3 modules
var Explanation = __webpack_require__(95204);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/images/other/product-with-plus.svg
var product_with_plus = __webpack_require__(23431);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(6493);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton.tsx + 1 modules
var OrderItemRemoveButton = __webpack_require__(65906);
// EXTERNAL MODULE: ./src/compositions/orderItems/util/useFirstProducts.ts
var useFirstProducts = __webpack_require__(97346);
;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionOrderItem/images/product-1.png
const product_1_namespaceObject = __webpack_require__.p + "images/product-1_bf895e.png";
;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionOrderItem/images/product-2.png
const product_2_namespaceObject = __webpack_require__.p + "images/product-2_b3f25c.png";
;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionOrderItem/images/product-3.png
const product_3_namespaceObject = __webpack_require__.p + "images/product-3_b88a6d.png";
;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionOrderItem/messages.ts
/* harmony default export */ const SubscriptionOrderItem_messages = ({
    title: {
        en: "What you’re getting..."
    },
    text: {
        en: "\n      A month-to-month subscription to Scentbird. Billed monthly,\n      renews automatically.\n    "
    },
    textWithDiscount: {
        en: '\n    Explore designer fragrances every month for a fraction of the normal retail price.\n    <b class="text-gold-70">Subscribe today and get {discountPercentage}% off your first month. Flexible plans, cancel anytime.</b>\n    '
    },
    textGift: {
        en: "\n      Because you bought a Gift Subscription for a friend, we're giving you two free months of Scentbird!\n      After the free period, you will be charged $16.95 each month to continue.\n    "
    },
    arrives: {
        en: "Arrives in {month}"
    },
    edit: {
        en: "Edit"
    },
    "case": {
        en: "A fragrance atomizer case"
    },
    emptyProduct: {
        en: "Your choice of one 8ml fragrance a month, with a\xa0free case included"
    },
    emptyProductMultiPlan: {
        en: "{productsPerPeriod} scents every month to fit your lifestyle, with a free case included"
    },
    firstFragrance: {
        en: "This is your first 8ml fragrance. You can see any others and edit them, once you’ve subscribed."
    },
    firstMultiFragrances: {
        en: "These are your 8ml fragrances for your first delivery. You can see any others and edit them, once you’ve subscribed."
    },
    productEmptyCell: {
        title: {
            en: "This is your {flatIndex, select, 0 {first} 1 {second} 2 {third}} fragrance"
        },
        note: {
            en: "If you haven’t chosen a scent, you’ll get our fragrance of the month."
        }
    },
    upcharge: {
        label: {
            en: "Plus {price}"
        },
        explanation: {
            title: {
                en: "What is a premium product?"
            },
            text: {
                en: "\n          Feeling fancy? Scentbird offers a limited run of super-luxe items.\n          Premium products will cost an additional $5, $10, or $15 depending on the item, which you'll see reflected in\n          your account should you choose to include one. <br /><br />\n          When you opt for a premium product surcharge will be applied to all subscription types including referrals,\n          gift cards, and limited-time offers.\n        "
            }
        }
    },
    free: {
        en: "Free!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionOrderItem/SubscriptionOrderItem.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
























var productsPerPeriodToImage = {
    1: product_1_namespaceObject,
    2: product_2_namespaceObject,
    3: product_3_namespaceObject
};
var SubscriptionOrderItem = function(props) {
    var className = props.className, data = props.data, giftSubscriptionOffer = props.giftSubscriptionOffer, withRemoveButton = props.withRemoveButton, isThankYouPage = props.isThankYouPage, isDiscountShown = props.isDiscountShown;
    var deliveryDate = data.deliveryDate, freeProduct = data.freeProduct, plan = data.plan, price = data.price, priceWithDiscount = data.priceWithDiscount, discountPercentage = data.discountPercentage, subscriptionPromos = data.subscriptionPromos;
    var isUpchargeInfoPaymentEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.upchargeInfoPayment) === "b";
    var isPlanSelectionInPaymentEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.paymentPlanSelection) === "b";
    var isGiftSubscriptionOfferEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftSubscriptionOffer);
    var withGiftSubscriptionOffer = isGiftSubscriptionOfferEnabled && giftSubscriptionOffer;
    var _useFirstProducts = (0,useFirstProducts/* default */.Z)({
        data: data,
        isThankYouPage: isThankYouPage
    }), firstProducts = _useFirstProducts.firstProducts, isFetching = _useFirstProducts.isFetching, isSubmitting = _useFirstProducts.isSubmitting;
    var hasFirstProducts = (firstProducts === null || firstProducts === void 0 ? void 0 : firstProducts.length) > 0;
    (0,react.useEffect)(function() {
        if (hasFirstProducts) {
            void (0,manager/* preloadModal */.My)("firstProductModal");
        }
    }, [
        hasFirstProducts
    ]);
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
            pw: 100,
            h: 100,
            bgColor: "light-beige"
        });
    }
    var productsPerPeriod = (plan === null || plan === void 0 ? void 0 : plan.productsPerPeriod) || 1;
    var isSeveralProductsPlan = productsPerPeriod !== 1;
    var defaultCaseMessage = hasFirstProducts ? SubscriptionOrderItem_messages["case"] : isSeveralProductsPlan ? _object_spread_props(_object_spread({}, SubscriptionOrderItem_messages.emptyProductMultiPlan), {
        values: {
            productsPerPeriod: productsPerPeriod
        }
    }) : SubscriptionOrderItem_messages.emptyProduct;
    var caseMessage = withGiftSubscriptionOffer ? giftSubscriptionOffer.description : defaultCaseMessage;
    var promoNodes = subscriptionPromos === null || subscriptionPromos === void 0 ? void 0 : subscriptionPromos.map(function(subscriptionPromo) {
        var title = subscriptionPromo.title, promo = subscriptionPromo.promo, amount = subscriptionPromo.amount;
        var id = promo.id, image = promo.image, rebrandImage = promo.rebrandImage, size = promo.size;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
            className: "mt-24",
            price: null,
            name: title,
            image: image,
            rebrandImage: rebrandImage,
            quantity: amount,
            size: size,
            "data-testid": "subscriptionPromo"
        }, "promo-".concat(id));
    });
    var subscriptionPrice = hasFirstProducts ? null : price;
    var productImage = productsPerPeriodToImage[productsPerPeriod];
    var withDiscount = isDiscountShown && discountPercentage;
    var isPriceWithDiscount = withDiscount && subscriptionPrice !== priceWithDiscount;
    var priceNode;
    if (withGiftSubscriptionOffer) {
        priceNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            message: giftSubscriptionOffer.priceOfferText,
            style: "t2"
        });
    } else if (isPriceWithDiscount && !hasFirstProducts) {
        priceNode = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-right",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "line-through",
                    message: subscriptionPrice,
                    style: "t2",
                    "data-testid": "price"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: priceWithDiscount,
                    style: "t2"
                })
            ]
        });
    }
    var caseNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
        className: "mt-24",
        image: withGiftSubscriptionOffer ? giftSubscriptionOffer.image : isPlanSelectionInPaymentEnabled ? productImage : null,
        rebrandImage: withGiftSubscriptionOffer ? giftSubscriptionOffer.image : isPlanSelectionInPaymentEnabled ? productImage : null,
        price: (withGiftSubscriptionOffer || isPriceWithDiscount) && !hasFirstProducts ? undefined : subscriptionPrice,
        priceNode: priceNode,
        "data-testid": "subscriptionCase",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            message: caseMessage,
            style: "p2"
        })
    }, "case");
    var freeProductNode = freeProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
        className: "mt-24",
        image: freeProduct.image,
        rebrandImage: freeProduct.rebrandImage,
        name: freeProduct.name,
        brand: freeProduct.brand,
        size: freeProduct.size,
        price: null,
        "data-testid": "freeProduct"
    }, "free-product") : null;
    var chosenProductNodes = hasFirstProducts ? firstProducts.map(function(param) {
        var flatIndex = param.flatIndex, product = param.product, isEmpty = param.isEmpty, onEdit = param.onEdit;
        var hasUpcharge = isUpchargeInfoPaymentEnabled && Boolean(product === null || product === void 0 ? void 0 : product.upchargePrice);
        var upchargePrice = hasUpcharge && (0,formatPrice/* default */.Z)(product.upchargePrice, {
            removeZeroCents: true
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
            className: "mt-24",
            image: product === null || product === void 0 ? void 0 : product.image,
            rebrandImage: isEmpty ? product_with_plus : product.rebrandImage,
            priceNode: onEdit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "cursor-pointer text-p2 underline",
                onClick: onEdit,
                "data-testid": "editProduct",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                    value: SubscriptionOrderItem_messages.edit
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pl-24"
            }),
            "data-testid": isEmpty ? "firstProductEmpty" : "firstProduct",
            children: isEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "p3",
                        message: _object_spread_props(_object_spread({}, SubscriptionOrderItem_messages.productEmptyCell.title), {
                            values: {
                                flatIndex: flatIndex
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "p5",
                        color: "gold-70",
                        message: SubscriptionOrderItem_messages.productEmptyCell.note
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "mb-8",
                        style: "h8",
                        color: "gold-50",
                        message: product.brand
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "p3",
                        message: product.name
                    }),
                    hasUpcharge && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-8 flex items-center justify-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferLabel/* default */.Z, {
                                title: _object_spread_props(_object_spread({}, SubscriptionOrderItem_messages.upcharge.label), {
                                    values: {
                                        price: upchargePrice
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Explanation/* default */.Z, {
                                title: SubscriptionOrderItem_messages.upcharge.explanation.title,
                                text: SubscriptionOrderItem_messages.upcharge.explanation.text,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    className: "ml-8 py-4 underline",
                                    message: messages/* default */.Z.whatsThis,
                                    style: "p5"
                                })
                            })
                        ]
                    }),
                    !isSeveralProductsPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "mt-8",
                        style: "p5",
                        color: "gold-50",
                        message: SubscriptionOrderItem_messages.firstFragrance
                    })
                ]
            })
        }, flatIndex);
    }) : null;
    var text;
    if (withGiftSubscriptionOffer && giftSubscriptionOffer.whatYouAreGetting) {
        text = giftSubscriptionOffer.whatYouAreGetting;
    } else if (withDiscount) {
        text = _object_spread_props(_object_spread({}, SubscriptionOrderItem_messages.textWithDiscount), {
            values: {
                discountPercentage: discountPercentage
            }
        });
    } else {
        text = SubscriptionOrderItem_messages.text;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
        className: className,
        "data-testid": "orderSubscription",
        children: [
            withRemoveButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemRemoveButton/* default */.Z, {
                input: {
                    subscriptionItem: {
                        plan: plan.name
                    }
                },
                metadata: {
                    productType: "Fragrance subscription",
                    placement: "Drawer cart"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h9",
                message: SubscriptionOrderItem_messages.title,
                color: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-16 flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: text,
                        style: withDiscount ? "p4" : "p2",
                        color: "black",
                        html: true
                    }),
                    hasFirstProducts && (isPriceWithDiscount && !withGiftSubscriptionOffer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-24 text-right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: priceWithDiscount,
                                style: "t2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: "line-through",
                                message: price,
                                style: "t2",
                                "data-testid": "price"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: "ml-24",
                        message: price,
                        style: "t2",
                        "data-testid": "price"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-24",
                message: _object_spread_props(_object_spread({}, SubscriptionOrderItem_messages.arrives), {
                    values: {
                        month: deliveryDate.format("MMMM")
                    }
                }),
                style: "h9",
                color: "black",
                "data-testid": "delivery"
            }),
            isSeveralProductsPlan && hasFirstProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-8",
                message: SubscriptionOrderItem_messages.firstMultiFragrances,
                style: "p5",
                color: "gold-70"
            }),
            isSubmitting ? firstProducts === null || firstProducts === void 0 ? void 0 : firstProducts.map(function(param) {
                var flatIndex = param.flatIndex;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                    className: "mt-24",
                    pw: 100,
                    h: 100,
                    bgColor: "light-beige"
                }, flatIndex);
            }) : chosenProductNodes,
            promoNodes,
            caseNode,
            freeProductNode
        ]
    });
};
/* harmony default export */ const SubscriptionOrderItem_SubscriptionOrderItem = (SubscriptionOrderItem);


/***/ }),

/***/ 92167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FX: () => (/* binding */ LimitedDropOrderItem),
/* harmony export */   Wq: () => (/* binding */ DriftOrderItem),
/* harmony export */   fC: () => (/* binding */ DriftSubscriptionOrderItem)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98716);
/* harmony import */ var _OrderItemSkeleton_OrderItemSkeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72056);






var fallback = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_OrderItemSkeleton_OrderItemSkeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});














var DriftOrderItem = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "DriftOrderItem-DriftOrderItem";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | DriftOrderItem-DriftOrderItem */[__webpack_require__.e(255), __webpack_require__.e(3649)]).then(__webpack_require__.bind(__webpack_require__, 51598));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(51598);
        }
        return eval("require.resolve")("./DriftOrderItem/DriftOrderItem");
    }
}, {
    fallback: fallback
});
var DriftSubscriptionOrderItem = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "DriftSubscriptionOrderItem-DriftSubscriptionOrderItem";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | DriftSubscriptionOrderItem-DriftSubscriptionOrderItem */[__webpack_require__.e(255), __webpack_require__.e(6666)]).then(__webpack_require__.bind(__webpack_require__, 86426));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(86426);
        }
        return eval("require.resolve")("./DriftSubscriptionOrderItem/DriftSubscriptionOrderItem");
    }
}, {
    fallback: fallback
});
var LimitedDropOrderItem = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "LimitedDropOrderItem-LimitedDropOrderItem";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | LimitedDropOrderItem-LimitedDropOrderItem */[__webpack_require__.e(6471), __webpack_require__.e(9203)]).then(__webpack_require__.bind(__webpack_require__, 2434));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(2434);
        }
        return eval("require.resolve")("./LimitedDropOrderItem/LimitedDropOrderItem");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_OrderItemSkeleton_OrderItemSkeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        bgColor: "gray-20"
    })
});


/***/ }),

/***/ 97346:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28950);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45942);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83464);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6135);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_unshift_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54644);
/* harmony import */ var core_js_modules_es_array_unshift_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unshift_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4130);
/* harmony import */ var core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73074);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8055);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43474);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39479);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52983);
/* harmony import */ var date__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(64895);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(55222);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(75384);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(31978);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(5649);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(50556);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(5657);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(83901);
/* harmony import */ var modules_payment__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88828);
/* harmony import */ var modules_queue__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11982);
/* harmony import */ var components_feedback__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99687);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}























var useFirstProducts = function(param) {
    var data = param.data, isThankYouPage = param.isThankYouPage;
    var _ref = data || {}, deliveryDate = _ref.deliveryDate, plan = _ref.plan;
    var _ref1 = plan || {}, productsPerPeriod = _ref1.productsPerPeriod, planName = _ref1.name;
    // ATTN if it's a thankyou page, we need to display the actual user's queue
    var _useQueue = (0,modules_queue__WEBPACK_IMPORTED_MODULE_14__/* .useQueue */ .Ln)(isThankYouPage ? undefined : {
        forPlan: planName
    }), queueItems = _useQueue.items, isQueueFetching = _useQueue.isFetching, refetch = _useQueue.refetch;
    var _useQueueUpdateItem = _sliced_to_array((0,modules_queue__WEBPACK_IMPORTED_MODULE_14__/* .useQueueUpdateItem */ .DE)(), 2), queueUpdateItem = _useQueueUpdateItem[0], _useQueueUpdateItem_ = _useQueueUpdateItem[1], isUpdating = _useQueueUpdateItem_.isFetching;
    var _useQueueDeleteItem = _sliced_to_array((0,modules_queue__WEBPACK_IMPORTED_MODULE_14__/* .useQueueDeleteItem */ .xi)(), 2), queueDeleteItem = _useQueueDeleteItem[0], _useQueueDeleteItem_ = _useQueueDeleteItem[1], isDeleting = _useQueueDeleteItem_.isFetching;
    var inquireContext = (0,modules_payment__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
    var reFetchInquire = inquireContext === null || inquireContext === void 0 ? void 0 : inquireContext.submit;
    var modalWithLayersContext = (0,components_feedback__WEBPACK_IMPORTED_MODULE_16__/* .useModalWithLayers */ .y)();
    var openLayer = modalWithLayersContext === null || modalWithLayersContext === void 0 ? void 0 : modalWithLayersContext.openLayer;
    var _useForceUpdate = _sliced_to_array((0,hooks__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(), 2), forceUpdateId = _useForceUpdate[0], forceUpdate = _useForceUpdate[1];
    var firstProducts = (0,react__WEBPACK_IMPORTED_MODULE_13__.useMemo)(function() {
        if (!deliveryDate || isQueueFetching) {
            return null;
        }
        var availableProducts = [];
        var isQueueAvailable = (queueItems === null || queueItems === void 0 ? void 0 : queueItems.length) > 0;
        var firstMonthDeliveryDate = deliveryDate;
        var isDisabled = false;
        // if user is authorized and have a queue, we can use it
        if (isQueueAvailable) {
            var firstMonth = queueItems[0];
            firstMonthDeliveryDate = (0,date__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(new Date(firstMonth.year, firstMonth.month - 1, 1, 0, 0, 0, 0));
            isDisabled = firstMonth.stateOptions.isDisabled;
            // add products from first queue month if they exits
            firstMonth.products.filter(function(item) {
                var _item_tradingItem;
                return Boolean(item === null || item === void 0 ? void 0 : (_item_tradingItem = item.tradingItem) === null || _item_tradingItem === void 0 ? void 0 : _item_tradingItem.productInfo);
            }).forEach(function(param) {
                var flatIndex = param.flatIndex, _param_tradingItem = param.tradingItem, id = _param_tradingItem.id, isLimitedEdition = _param_tradingItem.isLimitedEdition, productInfo = _param_tradingItem.productInfo;
                availableProducts.push({
                    type: "queue",
                    flatIndex: flatIndex,
                    product: _object_spread_props(_object_spread({}, productInfo), {
                        productId: productInfo.id,
                        tradingItemId: id,
                        brand: productInfo.brandInfo.name,
                        isLimitedEdition: isLimitedEdition
                    })
                });
            });
        }
        // if current queue items is after delivery date, then we shouldn't display any product selection
        if (deliveryDate.isBefore(firstMonthDeliveryDate)) {
            return null;
        }
        // there can be products in postponed items, they have higher priority than queue
        var postponedItems = local_storage__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z.localStorageNames.queuePendingProducts);
        // first products to add
        var highPriorityProducts = local_storage__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z.localStorageNames.queueHighPriorityProducts);
        // last products to add
        var lowPriorityProducts = local_storage__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z.localStorageNames.queueLowPriorityProducts);
        if (postponedItems === null || postponedItems === void 0 ? void 0 : postponedItems.length) {
            var items = postponedItems.filter(function(param) {
                var product = param.product;
                return Boolean(product);
            }).map(function(param) {
                var product = param.product, metadata = param.metadata;
                return {
                    type: "postponed",
                    product: product,
                    metadata: metadata
                };
            });
            if (items.length) {
                var _availableProducts;
                (_availableProducts = availableProducts).unshift.apply(_availableProducts, _to_consumable_array(items));
            }
        }
        if (highPriorityProducts === null || highPriorityProducts === void 0 ? void 0 : highPriorityProducts.length) {
            var items1 = highPriorityProducts.filter(function(param) {
                var product = param.product;
                return Boolean(product);
            }).map(function(param) {
                var product = param.product, metadata = param.metadata;
                return {
                    type: "postponed",
                    product: product,
                    metadata: metadata
                };
            });
            if (items1.length) {
                var _availableProducts1;
                (_availableProducts1 = availableProducts).unshift.apply(_availableProducts1, _to_consumable_array(items1));
            }
        }
        if (lowPriorityProducts === null || lowPriorityProducts === void 0 ? void 0 : lowPriorityProducts.length) {
            var items2 = lowPriorityProducts.filter(function(param) {
                var product = param.product;
                return Boolean(product);
            }).map(function(param) {
                var product = param.product, metadata = param.metadata;
                return {
                    type: "postponed",
                    product: product,
                    metadata: metadata
                };
            });
            if (items2.length) {
                var _availableProducts2;
                (_availableProducts2 = availableProducts).push.apply(_availableProducts2, _to_consumable_array(items2));
            }
        }
        if (availableProducts.length) {
            // we should show all first products for the selected plan
            return new Array(productsPerPeriod).fill(null).map(function(value, index) {
                var _availableProducts_index;
                var availableProduct = availableProducts[index];
                var isEmpty = !availableProduct;
                // on thank you page queue may be locked already
                var onEdit = isDisabled ? null : function() {
                    var onContinue = function() {
                        var _ref = _async_to_generator(function(selectedProduct) {
                            var _selectedProduct_tradingItems_items, _selectedProduct_tradingItems, selectedTradingItem, selectedTradingItemId, _getAnalyticsContext, page, pageType, metadata, existingQueueItem, newHighPriorityProducts, newLowPriorityProducts, error;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            9,
                                            ,
                                            10
                                        ]);
                                        selectedTradingItem = (_selectedProduct_tradingItems = selectedProduct.tradingItems) === null || _selectedProduct_tradingItems === void 0 ? void 0 : (_selectedProduct_tradingItems_items = _selectedProduct_tradingItems.items) === null || _selectedProduct_tradingItems_items === void 0 ? void 0 : _selectedProduct_tradingItems_items[0];
                                        selectedTradingItemId = selectedTradingItem === null || selectedTradingItem === void 0 ? void 0 : selectedTradingItem.id;
                                        _getAnalyticsContext = (0,analytics__WEBPACK_IMPORTED_MODULE_21__/* .getAnalyticsContext */ .cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
                                        metadata = {
                                            page: page,
                                            pageType: pageType,
                                            placement: "First product popup"
                                        };
                                        // if selected product is already in the queue, we need to remove it first
                                        // otherwise user will get SAME_PERFUME error
                                        existingQueueItem = null;
                                        queueItems === null || queueItems === void 0 ? void 0 : queueItems.some(function(param) {
                                            var products = param.products;
                                            existingQueueItem = products === null || products === void 0 ? void 0 : products.find(function(item) {
                                                var _item_tradingItem;
                                                return (item === null || item === void 0 ? void 0 : (_item_tradingItem = item.tradingItem) === null || _item_tradingItem === void 0 ? void 0 : _item_tradingItem.id) === selectedTradingItemId;
                                            });
                                            return Boolean(existingQueueItem);
                                        });
                                        if (!existingQueueItem) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            queueDeleteItem({
                                                index: existingQueueItem.flatIndex,
                                                metadata: metadata
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (!((availableProduct === null || availableProduct === void 0 ? void 0 : availableProduct.type) === "queue" && !(selectedTradingItem === null || selectedTradingItem === void 0 ? void 0 : selectedTradingItem.isLimitedEdition))) return [
                                            3,
                                            7
                                        ];
                                        // for queue item and not LEP, just replace it and refetch our queue query
                                        return [
                                            4,
                                            queueUpdateItem({
                                                index: availableProduct.flatIndex,
                                                tradingItemId: selectedTradingItemId,
                                                metadata: metadata
                                            })
                                        ];
                                    case 3:
                                        _state.sent();
                                        return [
                                            4,
                                            refetch()
                                        ];
                                    case 4:
                                        _state.sent();
                                        if (!(typeof reFetchInquire === "function")) return [
                                            3,
                                            6
                                        ];
                                        // We need to re-fetch whole inquire to correctly display promo products (PF-1519)
                                        return [
                                            4,
                                            reFetchInquire()
                                        ];
                                    case 5:
                                        _state.sent();
                                        _state.label = 6;
                                    case 6:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        // in other cases, we should split postponed products to first items and last items
                                        // high-priority products are the first products in the queue
                                        newHighPriorityProducts = (highPriorityProducts || []).filter(function(param) {
                                            var productId = param.product.productId;
                                            return productId !== selectedProduct.id && productId !== (availableProduct === null || availableProduct === void 0 ? void 0 : availableProduct.product.productId);
                                        }).slice(0, productsPerPeriod);
                                        newHighPriorityProducts.splice(index < newHighPriorityProducts.length ? index : 0, 0, {
                                            position: "FIRST",
                                            metadata: metadata,
                                            product: (0,helpers__WEBPACK_IMPORTED_MODULE_22__/* .getAddItemProduct */ .I)({
                                                product: selectedProduct,
                                                tradingItem: selectedTradingItem
                                            })
                                        });
                                        // low-priority products will be added to the end of the queue
                                        newLowPriorityProducts = (lowPriorityProducts || postponedItems || []).filter(function(param) {
                                            var productId = param.product.productId;
                                            return productId !== selectedProduct.id && productId !== (availableProduct === null || availableProduct === void 0 ? void 0 : availableProduct.product.productId);
                                        });
                                        if (availableProduct === null || availableProduct === void 0 ? void 0 : availableProduct.product) {
                                            newLowPriorityProducts.push({
                                                position: "LAST",
                                                metadata: (availableProduct === null || availableProduct === void 0 ? void 0 : availableProduct.metadata) || metadata,
                                                product: availableProduct === null || availableProduct === void 0 ? void 0 : availableProduct.product
                                            });
                                        }
                                        local_storage__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z.setItem(helpers__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z.localStorageNames.queueHighPriorityProducts, newHighPriorityProducts);
                                        local_storage__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z.setItem(helpers__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z.localStorageNames.queueLowPriorityProducts, newLowPriorityProducts);
                                        // ATTN when user select first products we replace queuePendingProducts with another items
                                        local_storage__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z.removeItem(helpers__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z.localStorageNames.queuePendingProducts);
                                        forceUpdate();
                                        _state.label = 8;
                                    case 8:
                                        return [
                                            3,
                                            10
                                        ];
                                    case 9:
                                        error = _state.sent();
                                        (0,helpers__WEBPACK_IMPORTED_MODULE_23__/* .processError */ .wY)(error);
                                        return [
                                            3,
                                            10
                                        ];
                                    case 10:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function onContinue(selectedProduct) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    if (openLayer) {
                        openLayer("firstProduct", {
                            selectedTradingItemId: availableProduct === null || availableProduct === void 0 ? void 0 : availableProduct.product.tradingItemId,
                            onContinue: onContinue
                        });
                    } else {
                        (0,modals__WEBPACK_IMPORTED_MODULE_24__/* .openModal */ .h7)("firstProductModal", {
                            selectedTradingItemId: availableProduct === null || availableProduct === void 0 ? void 0 : availableProduct.product.tradingItemId,
                            onContinue: onContinue
                        });
                    }
                };
                return {
                    flatIndex: index,
                    product: (_availableProducts_index = availableProducts[index]) === null || _availableProducts_index === void 0 ? void 0 : _availableProducts_index.product,
                    isEmpty: isEmpty,
                    onEdit: onEdit
                };
            });
        }
        return null;
    }, [
        isQueueFetching,
        deliveryDate,
        queueItems,
        productsPerPeriod,
        openLayer,
        queueUpdateItem,
        queueDeleteItem,
        forceUpdate,
        refetch,
        reFetchInquire,
        forceUpdateId
    ]);
    // TODO implement edit functionality - added on 2021-09-27 by maddoger
    return {
        firstProducts: firstProducts,
        isFetching: isQueueFetching,
        isSubmitting: isUpdating || isDeleting
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFirstProducts);


/***/ }),

/***/ 31580:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ util_useOrderBill)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(83464);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(73281);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(83913);
;// CONCATENATED MODULE: ./src/compositions/orderItems/util/messages.ts
/* harmony default export */ const messages = ({
    free: {
        en: "Free"
    },
    alwaysFree: {
        en: "Always free"
    },
    subTotal: {
        en: "Subtotal"
    },
    total: {
        en: "Total"
    },
    surcharge: {
        en: "Premium product surcharge"
    },
    surchargeNote: {
        en: "This surcharge will be deducted from<br />your account after 12 hours"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/util/useOrderBill.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}













// formats bill info from cart / inquire / payment session
var useOrderBill = function(data) {
    var _ref = data || {}, firstProducts = _ref.firstProducts, tax = _ref.tax, shipping = _ref.shipping, discounts = _ref.discounts, credits = _ref.credits, subTotal = _ref.subTotal, total = _ref.total, purchaseLevel = _ref.purchaseLevel, isAlwaysFreeMessageEnabled = _ref.isAlwaysFreeMessageEnabled, isSubscriptionDiscountDisabled = _ref.isSubscriptionDiscountDisabled;
    var isUpchargeInfoPaymentEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.upchargeInfoPayment) === "b";
    var isGiftSubscriptionOfferEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftSubscriptionOffer);
    var isSubscriptionOnly = purchaseLevel === "SUBSCRIPTION_ONLY";
    var isFreeTrial = cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.isFreeTrialCoupon);
    return (0,react.useMemo)(function() {
        var _discounts_filter;
        if (typeof total === "undefined" || typeof subTotal === "undefined") {
            return [];
        }
        var discountItems = (discounts === null || discounts === void 0 ? void 0 : (_discounts_filter = discounts.filter(function(param) {
            var coupon = param.coupon, label = param.label;
            if (isGiftSubscriptionOfferEnabled && (coupon === null || coupon === void 0 ? void 0 : coupon.code) === "NO_CHARGE") {
                return false;
            }
            if (isSubscriptionDiscountDisabled && label.toLocaleLowerCase().includes("subscription")) {
                return false;
            }
            return true;
        })) === null || _discounts_filter === void 0 ? void 0 : _discounts_filter.map(function(param) {
            var label = param.label, note = param.note, amount = param.amount, unit = param.unit;
            return {
                label: label,
                note: note,
                value: unit && unit !== "$" ? "- ".concat(amount).concat(unit) : (0,formatPrice/* default */.Z)(amount * -1),
                dataTestId: "discount"
            };
        })) || [];
        var creditsItems = (credits === null || credits === void 0 ? void 0 : credits.map(function(param) {
            var label = param.label, amount = param.amount;
            return {
                label: label,
                value: (0,formatPrice/* default */.Z)(amount * -1),
                dataTestId: "credits"
            };
        })) || [];
        var shippingItems = (shipping === null || shipping === void 0 ? void 0 : shipping.map(function(param) {
            var label = param.label, note = param.note, price = param.price;
            var isAlwaysFreeMessage = isAlwaysFreeMessageEnabled && !isFreeTrial && (label.match(/subscription/i) || isSubscriptionOnly);
            var freeMessage = isAlwaysFreeMessage ? messages.alwaysFree : messages.free;
            return {
                label: label,
                note: note,
                value: price ? (0,formatPrice/* default */.Z)(price) : freeMessage,
                dataTestId: "shipping"
            };
        })) || [];
        var surchargeItems = isUpchargeInfoPaymentEnabled && (firstProducts === null || firstProducts === void 0 ? void 0 : firstProducts.map(function(param) {
            var product = param.product;
            return {
                disabled: true,
                label: messages.surcharge,
                value: (0,formatPrice/* default */.Z)(product.upchargePrice),
                note: messages.surchargeNote,
                noteColor: "gold-50"
            };
        })) || [];
        var taxItems = tax ? [
            {
                label: tax.label,
                value: (0,formatPrice/* default */.Z)(tax.amount),
                dataTestId: "tax"
            }
        ] : [];
        // subtotal, discounts, credits, shipping, taxes, total
        return [
            {
                label: messages.subTotal,
                value: (0,formatPrice/* default */.Z)(subTotal),
                isSubTotal: true,
                dataTestId: "subtotal"
            }
        ].concat(_to_consumable_array(discountItems), _to_consumable_array(creditsItems), _to_consumable_array(surchargeItems), _to_consumable_array(shippingItems), _to_consumable_array(taxItems), [
            {
                label: messages.total,
                value: (0,formatPrice/* default */.Z)(total),
                isTotal: true,
                dataTestId: "total"
            }
        ]);
    }, [
        credits,
        discounts,
        firstProducts,
        isAlwaysFreeMessageEnabled,
        isSubscriptionDiscountDisabled,
        isFreeTrial,
        isGiftSubscriptionOfferEnabled,
        isSubscriptionOnly,
        isUpchargeInfoPaymentEnabled,
        shipping,
        subTotal,
        tax,
        total
    ]);
};
/* harmony default export */ const util_useOrderBill = (useOrderBill);


/***/ }),

/***/ 11748:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28950);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6135);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83464);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45942);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_date_now_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25503);
/* harmony import */ var core_js_modules_es_date_now_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_now_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96837);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52983);
/* harmony import */ var date__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64895);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50556);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86478);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(72160);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97723);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68426);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}














// returns order items from inquire, cart, payment session
var useOrderItems = function(data) {
    var isCartEcommercePromosEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.features.cartEcommercePromos);
    var isGwpBuyYourQueueEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.features.gwpBuyYourQueue);
    var isGiftSubscriptionOfferEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.features.giftSubscriptionOffer);
    var isLimitedDropsEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.features.limitedDrops);
    return (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(function() {
        if (!data) {
            return {};
        }
        var ecommercePromos = data.ecommercePromos, giftCard = data.giftCard, giftSubscription = data.giftSubscription, limitedDropItems = data.limitedDropItems, products = data.products, queueItems = data.queueItems, queuePromos = data.queuePromos, subscription = data.subscription, subscriptionCase = data.subscriptionCase, subscriptionPromos = data.subscriptionPromos;
        var items = {};
        if (subscription) {
            var price = subscription.price, plan = subscription.plan, coupon = subscription.coupon;
            var couponFreeProduct = coupon === null || coupon === void 0 ? void 0 : coupon.freeProduct;
            var freeProduct = couponFreeProduct ? {
                id: couponFreeProduct.id,
                name: couponFreeProduct.name,
                brand: couponFreeProduct.brandInfo.name,
                image: couponFreeProduct.image,
                rebrandImage: couponFreeProduct.rebrandImage,
                size: (0,helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(couponFreeProduct.volume, couponFreeProduct.unit)
            } : null;
            var subscriptionPromosItems = subscriptionPromos === null || subscriptionPromos === void 0 ? void 0 : subscriptionPromos.map(function(param) {
                var title = param.title, amount = param.amount, promo = param.promo;
                return {
                    title: title,
                    amount: amount,
                    promo: _object_spread_props(_object_spread({}, promo), {
                        size: (0,helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(promo.volume, promo.unit)
                    })
                };
            });
            var discountPercentage = coupon === null || coupon === void 0 ? void 0 : coupon.discountPercentage;
            var priceWithDiscount = discountPercentage ? price * ((100 - discountPercentage) / 100) : undefined;
            items.subscription = {
                deliveryDate: (0,date__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)().add(5, "days"),
                price: (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(price),
                priceWithDiscount: (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(priceWithDiscount),
                discountPercentage: discountPercentage,
                plan: plan,
                subscriptionPromos: subscriptionPromosItems,
                subscriptionCase: subscriptionCase,
                freeProduct: freeProduct
            };
        }
        if (queueItems) {
            items.queueItems = queueItems.map(function(param) {
                var id = param.id, price = param.price, product = param.product;
                return _object_spread_props(_object_spread({}, product), {
                    id: id,
                    quantity: 1,
                    brand: product.brandInfo.name,
                    size: "".concat(product.volume, " ").concat(product.unit),
                    price: (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(price)
                });
            });
            if (isGwpBuyYourQueueEnabled && queuePromos) {
                queuePromos.forEach(function(param) {
                    var id = param.id, price = param.price, quantity = param.quantity, product = param.product, offer = param.offer;
                    var item = _object_spread_props(_object_spread({}, product), {
                        id: id,
                        brand: null,
                        productId: product.id,
                        size: (0,helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(product.volume, product.unit),
                        price: price !== 0 ? (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(price) : null,
                        quantity: quantity,
                        offer: offer
                    });
                    items.queueItems.push(item);
                });
            }
        }
        if (giftSubscription) {
            var plan1 = giftSubscription.plan, price1 = giftSubscription.price, label = giftSubscription.label, recipient = giftSubscription.recipient, offer = giftSubscription.offer;
            items.giftSubscription = {
                months: plan1.billingPeriod,
                price: (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(price1),
                label: label,
                recipient: helpers__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z.removeKeys(recipient, "__typename")
            };
            if (isGiftSubscriptionOfferEnabled && offer) {
                items.giftSubscriptionOffer = offer;
            }
        }
        if (giftCard) {
            var product = giftCard.product, price2 = giftCard.price, type = giftCard.type, recipient1 = giftCard.recipient, sender = giftCard.sender;
            items.giftCard = {
                productId: product.id,
                price: (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(price2, {
                    removeZeroCents: true
                }),
                type: type,
                recipient: helpers__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z.removeKeys(recipient1, "__typename"),
                sender: helpers__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z.removeKeys(sender, "__typename")
            };
        }
        var offerItemsByParentId = {};
        var ecommercePromoProducts = [];
        if (isCartEcommercePromosEnabled && ecommercePromos) {
            ecommercePromos.forEach(function(param) {
                var id = param.id, price = param.price, quantity = param.quantity, product = param.product, offer = param.offer, parentPurchaseTradingItemId = param.parentPurchaseTradingItemId;
                var item = _object_spread_props(_object_spread({}, product), {
                    type: product.type,
                    typeGroup: product.typeGroup,
                    id: id,
                    productId: product.id,
                    brand: product.brandInfo.name,
                    size: (0,helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(product.volume, product.unit),
                    quantity: quantity,
                    price: price !== 0 ? (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(price) : null,
                    offer: offer,
                    offerProducts: [],
                    isRemovable: false
                });
                if (product.typeGroup === "PerfumeCase" && quantity > 1) {
                    item.size = "";
                }
                if (parentPurchaseTradingItemId) {
                    offerItemsByParentId[parentPurchaseTradingItemId] = offerItemsByParentId[parentPurchaseTradingItemId] || [];
                    offerItemsByParentId[parentPurchaseTradingItemId].push(item);
                } else {
                    ecommercePromoProducts.push(item);
                }
            });
        }
        if (isLimitedDropsEnabled && limitedDropItems) {
            items.limitedDrops = limitedDropItems.filter(function(param) {
                var isPromo = param.isPromo;
                return !isPromo;
            }).map(function(param) {
                var countdownState = param.countdownState, expiredDate = param.expiredDate, giftProducts = param.giftProducts, id = param.id, image = param.image, price = param.price, product = param.product, productState = param.productState, quantity = param.quantity;
                var _giftProducts_;
                var remainingTime = expiredDate ? new Date(expiredDate).getTime() - Date.now() : 0;
                var item = _object_spread_props(_object_spread({}, product), {
                    brand: product.brandInfo.name,
                    countdownState: countdownState,
                    giftDescription: giftProducts === null || giftProducts === void 0 ? void 0 : (_giftProducts_ = giftProducts[0]) === null || _giftProducts_ === void 0 ? void 0 : _giftProducts_.title,
                    id: id,
                    image: image || product.rebrandImage || product.image,
                    price: price !== 0 ? (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(price) : null,
                    productId: product.id,
                    productState: productState,
                    quantity: quantity,
                    remainingTime: remainingTime,
                    size: (0,helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(product.volume, product.unit)
                });
                return item;
            });
        }
        if (products) {
            items.products = products.reduce(function(result, param) {
                var id = param.id, price = param.price, quantity = param.quantity, product = param.product, offer = param.offer, parentPurchaseTradingItemId = param.parentPurchaseTradingItemId, drift = param.drift, variety = param.variety;
                // we use reference to this object
                offerItemsByParentId[id] = offerItemsByParentId[id] || [];
                var item = _object_spread_props(_object_spread({}, product), {
                    id: id,
                    productId: product.id,
                    brand: product.brandInfo.name,
                    size: (0,helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(product.volume, product.unit),
                    quantity: quantity,
                    price: price !== 0 ? (0,helpers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(price) : null,
                    offer: offer,
                    offerProducts: offerItemsByParentId[id],
                    isRemovable: true,
                    drift: drift,
                    variety: variety
                });
                // we merge all offers except TOSS IN
                if (offer === "TOSSIN" || offer === "TOSSIN_EMAIL") {
                    result.push(item);
                    return result;
                }
                if (parentPurchaseTradingItemId) {
                    // special case for academy course kit
                    // if FT is enabled we get offer items from ecommercePromos
                    if (offer === "ACADEMY_COURSE_KIT" || !isCartEcommercePromosEnabled) {
                        offerItemsByParentId[parentPurchaseTradingItemId] = offerItemsByParentId[parentPurchaseTradingItemId] || [];
                        offerItemsByParentId[parentPurchaseTradingItemId].push(item);
                    }
                } else {
                    result.push(item);
                }
                return result;
            }, []);
        }
        if (items.products) {
            var _items_products;
            (_items_products = items.products).push.apply(_items_products, _to_consumable_array(ecommercePromoProducts));
        } else {
            items.products = ecommercePromoProducts;
        }
        return items;
    }, [
        data,
        isCartEcommercePromosEnabled,
        isGiftSubscriptionOfferEnabled,
        isGwpBuyYourQueueEnabled,
        isLimitedDropsEnabled
    ]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useOrderItems);


/***/ })

}]);